function onGeoSuccess(res) {
  if (!localStorage.getItem('saved_currency')) {
    var selected_cur = 'USD';

    if (res.continent.code == 'EU') {
      selected_cur = 'EUR';
    }

    if (res.country.iso_code == 'AU') {
      selected_cur = 'AUD';
    }

    if (res.country.iso_code == 'BR') {
      selected_cur = 'BRL';
    }

    if (res.country.iso_code == 'CA') {
      selected_cur = 'CAD';
    }

    if (res.country.iso_code == 'CH') {
      selected_cur = 'CHF';
    }

    if (res.country.iso_code == 'DK') {
      selected_cur = 'DKK';
    }

    if (res.country.iso_code == 'GB' || res.country.iso_code == 'UK') {
      selected_cur = 'GBP';
    }

    if (res.country.iso_code == 'HK') {
      selected_cur = 'HKD';
    }

    if (res.country.iso_code == 'NO') {
      selected_cur = 'NOK';
    }

    if (res.country.iso_code == 'NZ') {
      selected_cur = 'NZD';
    }

    if (res.country.iso_code == 'SE') {
      selected_cur = 'SEK';
    }

    if (res.country.iso_code == 'ZA') {
      selected_cur = 'ZAR';
    }

    if (res.country.iso_code == 'JP') {
      selected_cur = 'YEN';
    }

    if (selected_cur != 'USD') {
      document.querySelector('.currency-wrapper [data-cur="' + selected_cur + '"]').click();
    }
  }

  console.log('ip location = ', res.country.iso_code);

  
  if (res.country.iso_code != 'US') {
    document.querySelector('body').classList.add('outside-us');
    document.dispatchEvent(new Event('locationDetectedOutsideUS'));
  } else {
    document.querySelector('body').classList.add('inside-us');
    document.dispatchEvent(new Event('locationDetectedInsideUS'));
  }

  localStorage.setItem('geo', res.country.iso_code);
}

function onGeoError(res) {
  console.log('Geo error', res);
}

// Geo Location
if (typeof geoip2 !== 'undefined') {
  geoip2.country(onGeoSuccess, onGeoError);
}
